import request from '@/plugin/axios'
import cryptoJS from '@/libs/util.cryptoJS.js'

export function AccountLogin(data) {
	return request({
		 //url: '/AccountLogin',
		url:'api/AccountLogin',
		method: 'post',
		//data: cryptoJS.aesEncryptObj2Obj(data)
		data:data
	})
}

export function GetAuthKeys(data) {
	return request({
		//url: '/GetAuthKeys',
		url: 'api/GetAuthKeys',
		method: 'post',
		data: cryptoJS.aesEncryptObj2Obj(data)
	})
}

export function GetMenuTreeOnAuth(data) {
	return request({
		//url: '/GetMenuTreeOnAuth',
		url: 'api/GetMenuTreeOnAuth',
		method: 'post',
		data: cryptoJS.aesEncryptObj2Obj(data)
		//data:data
	})
}

export function Query(data) {
	return request({
		//url: '/Query',
		url: '/query',
		method: 'post',
		data: cryptoJS.aesEncryptObj2Obj(data)
		//data:data
	})
}